import React, { useContext } from 'react';
import Video from 'twilio-video';
import VideoProvider, { VideoContext } from './components/VideoProvider';
import VideoRoomI18nProvider from './components/VideoRoomI18n';
import Room from './components/Room';
import Controls from './components/Controls';
import { DeviceSelector } from './components/Controls/DeviceSelector';
import useRoomState, { RoomState } from './hooks/useRoomState';
import useLocalAudioToggle from './hooks/useLocalAudioToggle';
import useLocalVideoToggle from './hooks/useLocalVideoToggle';
import useMediaStreamTrack from './hooks/useMediaStreamTrack';
export default function CaazamVideoRoom(_ref) {
  var _ref$toggleControls = _ref.toggleControls,
      toggleControls = _ref$toggleControls === void 0 ? true : _ref$toggleControls,
      _ref$i18nFormatter = _ref.i18nFormatter,
      i18nFormatter = _ref$i18nFormatter === void 0 ? null : _ref$i18nFormatter,
      _ref$videoProcessor = _ref.videoProcessor,
      videoProcessor = _ref$videoProcessor === void 0 ? null : _ref$videoProcessor;
  var roomState = useRoomState();
  return /*#__PURE__*/React.createElement(VideoRoomI18nProvider, {
    formatter: i18nFormatter
  }, /*#__PURE__*/React.createElement("div", {
    id: "VideoRoom",
    style: {
      overflow: 'hidden',
      height: '100%',
      width: '100%',
      background: '#F0F0F0',
      position: 'relative'
    }
  }, roomState !== RoomState.disconnected && /*#__PURE__*/React.createElement(Room, {
    showOverlays: toggleControls,
    videoProcessor: videoProcessor
  }), /*#__PURE__*/React.createElement(Controls, {
    showControls: toggleControls
  })));
}
export function usePublicVideoContext() {
  var context = useContext(VideoContext);

  if (!context) {
    throw new Error('usePublicVideoContext must be used within a VideoProvider');
  }

  var getLocalTracks = context.getLocalTracks,
      localTracks = context.localTracks,
      connect = context.connect,
      disconnect = context.disconnect,
      republishTracks = context.republishTracks,
      participantsInfo = context.participantsInfo,
      setParticipantsInfo = context.setParticipantsInfo,
      replaceAudioInputDevice = context.replaceAudioInputDevice,
      replaceVideoInputDevice = context.replaceVideoInputDevice,
      replaceAudioOutputDevice = context.replaceAudioOutputDevice,
      isAcquiringLocalTracks = context.isAcquiringLocalTracks,
      addProcessorToVideoTrack = context.addProcessorToVideoTrack,
      deleteProcessorFromVideoTrack = context.deleteProcessorFromVideoTrack;
  return {
    getLocalTracks: getLocalTracks,
    localTracks: localTracks,
    connect: connect,
    disconnect: disconnect,
    republishTracks: republishTracks,
    participantsInfo: participantsInfo,
    setParticipantsInfo: setParticipantsInfo,
    replaceAudioInputDevice: replaceAudioInputDevice,
    replaceVideoInputDevice: replaceVideoInputDevice,
    replaceAudioOutputDevice: replaceAudioOutputDevice,
    isAcquiringLocalTracks: isAcquiringLocalTracks,
    addProcessorToVideoTrack: addProcessorToVideoTrack,
    deleteProcessorFromVideoTrack: deleteProcessorFromVideoTrack
  };
}
var isBrowserSupported = Video.isSupported;

var getVideoLogger = function getVideoLogger() {
  return Video.Logger.getLogger('twilio-video');
};

export { VideoProvider as CaazamVideoProvider, usePublicVideoContext as useCaazamVideoContext, useMediaStreamTrack, useLocalAudioToggle, useLocalVideoToggle, isBrowserSupported, getVideoLogger, DeviceSelector };